import { Trans } from 'react-i18next'

import { cn } from '@/lib/utils'
import { ROUTES } from '@/navigation/constants'

import { Checkbox } from './ui/checkbox'

type MetaAdsAttributionConsentBlockProps = {
    consentChecked: boolean
    onCheckedChange: (checked: boolean) => void
    consentInputId?: string
    labelClassName?: string
}

const policyLinkClassName = 'font-medium text-primary underline-offset-2 hover:underline'

export function MetaAdsAttributionConsentBlock({
    consentChecked,
    onCheckedChange,
    consentInputId = 'meta-ads-attribution-consent',
    labelClassName,
}: MetaAdsAttributionConsentBlockProps) {
    return (
        <div className='flex items-start gap-2'>
            <Checkbox
                id={consentInputId}
                checked={consentChecked}
                onCheckedChange={checked => onCheckedChange(checked === true)}
                className='mt-0.5'
            />
            <label
                htmlFor={consentInputId}
                className={cn(
                    'text-sm leading-snug peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
                    labelClassName,
                )}
            >
                <Trans
                    i18nKey='leadForm.metaAdsConsentText'
                    components={{
                        privacyLink: (
                            <a
                                href={ROUTES.privacyPolicy}
                                className={policyLinkClassName}
                                onClick={event => event.stopPropagation()}
                            />
                        ),
                        cookieLink: (
                            <a
                                href={ROUTES.cookiePolicy}
                                className={policyLinkClassName}
                                onClick={event => event.stopPropagation()}
                            />
                        ),
                    }}
                />
            </label>
        </div>
    )
}
